<template>
  <div class="app flex-row align-items-center" v-if="showInputDialog">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form>
                  <h1>Login</h1>
                  <p class="text-muted">Sign In to your account</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="text" v-model="username" @keyup.enter="login();" class="form-control" placeholder="Username" autocomplete="username email" />
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="password" v-model="password" @keyup.enter="login();" class="form-control" placeholder="Password" autocomplete="current-password" />
                  </b-input-group>
                  <b-row>
                    <b-col cols="6">
                      <b-button variant="primary" class="px-4" @click="login();">Login</b-button>
                    </b-col>
                    <b-col cols="6" class="text-right">
                      <b-button variant="link" class="px-0">Forgot password?</b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
            <b-card no-body class="text-white bg-primary py-5 d-md-down-none" style="width:44%">
              <b-card-body class="text-center">
                <div>
                  <h2>Sign up</h2>
                  <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                  <b-button variant="primary" class="active mt-3">Register Now!</b-button>
                </div>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
    <b-modal title="권한 범위 확인"
      v-model="scopeModal"
      @ok="answerScope(true)"
      @cancel="answerScope(false)"
    >
      {{ scopeModalMessage }}
    </b-modal>
  </div>
</template>

<script>
import VueNotifications from 'vue-notifications'
import DevAuthorize from '@/shared/dev-authorize'

// import Vue from 'vue'
export default {
  name: 'Login',
  data () {
    return {
      username:"",
      password:"",
      logined: this.isLogined(),
      showInputDialog: false,
      scopeModal: false,
      scopeModalMessage: "",
    }
  },
  notifications: {
    showNotificationMessage: {
      type: VueNotifications.types.success
    },
    showErrorMessage: {
      type: VueNotifications.types.error,
      title: 'Error',
      message: 'Error...'
    },
  },
  beforeCreate: function () {
  },
  created : function() {
    const _vm = this;
    DevAuthorize.validate(this, (res, code, message) => {
      if(res) {
        if (!_vm.$session.exists()) {
          _vm.$session.start()
        }
        _vm.$router.push('/dashboard')
      } else {
          if(message) {
            // alert(message);
            _vm.showErrorMessage({message: message});
          }
        _vm.$session.destroy()
        _vm.showInputDialog = true;
      }
    });
  },
  methods: {
    login: function () {
      const _vm = this;
      DevAuthorize.login(this, this.username, this.password, (res, code, message, data) => {
        if(res) {
          if(code === "2001") {
            _vm.inqueryScope(data, false);
          } else if(code === "2002") {
            _vm.inqueryScope(data, true);
          } else {
            if (!_vm.$session.exists()) {
              _vm.$session.start()
            }
            _vm.$router.push('/dashboard')
          }
        } else {
          if(message) {
            // alert(message);
            _vm.showErrorMessage({message: message});
          }
          _vm.username = "";
          _vm.password = "";
        }
      });
    },
    inqueryScope: function(token, changed) {
      const scope = token.scope.join(", ");
      this.scopeModalMessage = "현재의 계정으로 권한이 승인되지 않았습니다. 다음 권한(" + scope + ")을 승인하시겠습니까? 일부 페이지는 계정의 권한에 따라 접속이 차단될 수 있습니다."
      if(changed) {
        this.scopeModalMessage = "현재의 계정으로 승인되었던 권한이 변경되었습니다. 다음 권한(" + scope + ")으로 다시 승인하시겠습니까? 일부 페이지는 계정의 권한에 따라 접속이 차단될 수 있습니다."
      }
      this.scopeModal = true;
    },
    answerScope: function(answer) {
      this.scopeModal = false;

      if(answer) {
        const _vm = this;
        DevAuthorize.allowScope(this, (res, code, message) => {
          if(res) {
            if (!_vm.$session.exists()) {
              _vm.$session.start()
            }
            _vm.$router.push('/dashboard')
          } else {
            if(message) {
              // alert(message);
              _vm.showErrorMessage({message: message});
            }
            _vm.username = "";
            _vm.password = "";
          }
        });
      } else {
        //
      }
    },
    isLogined: function() {
      const token = this.$store.getters.getToken;
      return this.$session.exists() && token;
    }
  }
}
</script>
